// Anmeldeprobe (Schlusslauf 3, 10.10.2026): was die Seite /sso sagt, wenn der Link der Partnerfirma nicht angenommen wird.
// POST /sso/entry antwortet der Partneranwendung mit technischen Meldungen auf Englisch („Invalid token format“, „Token
// already used“); für Menschen gedacht sind nur die Antworten mit Code (deutsche Sätze, etwa „Organisation gesperrt.“).
// Alles andere bekommt den einen Satz mit dem Weg weiter. Reine Funktion, geprüft in frontend/tests/sso-fehler.test.mjs.
export const SSO_FEHLER = 'Der Anmeldelink konnte nicht bestätigt werden. Fordern Sie einen neuen Link bei Ihrer Firma an oder verwenden Sie Ihr CLAiRIS-Konto.';

export function ssoFehlerText(error: unknown): string {
  const antwort = (error as { response?: { data?: { code?: unknown; error?: unknown } } } | null)?.response?.data;
  return typeof antwort?.code === 'string' && typeof antwort.error === 'string' && antwort.error ? antwort.error : SSO_FEHLER;
}
